import { render, staticRenderFns } from "./ConfigureDocTypeDocument.vue?vue&type=template&id=76dbaf60&scoped=true"
import script from "./ConfigureDocTypeDocument.vue?vue&type=script&lang=js"
export * from "./ConfigureDocTypeDocument.vue?vue&type=script&lang=js"
import style0 from "./ConfigureDocTypeDocument.vue?vue&type=style&index=0&id=76dbaf60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dbaf60",
  null
  
)

export default component.exports